import type { AxiosResponse } from "axios";
import api from "./api/api";
import type {
  ChatCallActionPayload,
  ChatCallApiResponse,
  ChatCallCreatePayload,
} from "@/types/chatCall";

type ErrorResponse = {
  response?: AxiosResponse<ChatCallApiResponse>;
};

function getErrorResponse(error: unknown) {
  return (error as ErrorResponse | null)?.response;
}

const ChatCallService = {
  create: async (payload: ChatCallCreatePayload) => {
    try {
      const res = await api.post<ChatCallApiResponse>("/chat/calls", payload);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  getCurrent: async (callId: string) => {
    try {
      const res = await api.get<ChatCallApiResponse>(`/chat/calls/${callId}`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  getCurrentActive: async () => {
    try {
      const res = await api.get<ChatCallApiResponse>("/chat/calls/current/active");
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  accept: async (callId: string) => {
    try {
      const res = await api.post<ChatCallApiResponse>(`/chat/calls/${callId}/accept`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  connected: async (callId: string) => {
    try {
      const res = await api.post<ChatCallApiResponse>(`/chat/calls/${callId}/connected`);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  reject: async (callId: string, payload: ChatCallActionPayload = {}) => {
    try {
      const res = await api.post<ChatCallApiResponse>(
        `/chat/calls/${callId}/reject`,
        payload,
      );
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  cancel: async (callId: string, payload: ChatCallActionPayload = {}) => {
    try {
      const res = await api.post<ChatCallApiResponse>(
        `/chat/calls/${callId}/cancel`,
        payload,
      );
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  end: async (callId: string, payload: ChatCallActionPayload = {}) => {
    try {
      const res = await api.post<ChatCallApiResponse>(`/chat/calls/${callId}/end`, payload);
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },

  failure: async (callId: string, payload: ChatCallActionPayload = {}) => {
    try {
      const res = await api.post<ChatCallApiResponse>(
        `/chat/calls/${callId}/failure`,
        payload,
      );
      return res;
    } catch (error: unknown) {
      return getErrorResponse(error);
    }
  },
};

export default ChatCallService;
